module.exports = __webpack_public_path__ + "static/media/cq_imbuto b.cc14ebd4.svg";